/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { markErrorAsHandled } from '@confluence/graphql';
import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';

export const useIsPrivacyModeEnabled = (): boolean => {
	const { cloudId } = useSessionData();
	const { data, error } = useQuery(
		gql`
			query useIsPrivacyModeEnabledQuery($cloudId: ID!) {
				confluence_isPrivacyModeEnabled(cloudId: $cloudId) {
					isPrivacyModeEnabled
				}
			}
		`,
		{
			variables: {
				cloudId,
			},
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			skip: !fg('ccir_privacy_mode') || Boolean(process.env.REACT_SSR),
		},
	);

	if (error) {
		// We dont care about the error, thus we handle it silently
		markErrorAsHandled(error);
		// Return true to avoid any privacy leakage.
		return true;
	}

	return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};
